<template>
  <BMDialog
    showDialog
    :headerText="$t('userProfile.changePassword')"
    :disableConfirm="!isFormValid || isLoading"
    :loading="isLoading"
    width="440"
    dialogTestId="change-password-dialog"
    @closed="closeDialog"
    @confirmed="updatePassword"
  >
    <v-form v-model="isFormValid">
      <v-row>
        <v-col cols="12">
          <input
            v-show="false"
            type="text"
            name="username"
            tabindex="-1"
            :value="
              $userProfile.profile?.username || $userProfile.profile?.email
            "
            data-cc="change-password-dialog-username"
          />

          <BMPasswordField
            v-model="oldPassword"
            autocomplete="current-password"
            :label="$t('userProfile.oldPassword', { required: '*' })"
            :rules="oldPwdRules"
            data-cc="change-password-dialog-old-password"
          />
        </v-col>

        <v-col cols="12">
          <BMPasswordField
            v-model="newPassword"
            autocomplete="new-password"
            :label="
              $t('accountHandling.changePassword.labels.newPassword', {
                required: '*'
              })
            "
            :rules="differentPwdRules"
            data-cc="change-password-dialog-new-password"
          />
        </v-col>

        <v-col cols="12">
          <BMPasswordField
            v-model="newPasswordRepeat"
            autocomplete="new-password"
            :label="
              $t('accountHandling.changePassword.labels.newPasswordRepeat', {
                required: '*'
              })
            "
            :rules="confirmPasswordRules"
            data-cc="change-password-dialog-repeat-password"
          />
        </v-col>
      </v-row>
    </v-form>
  </BMDialog>
</template>

<script setup>
import { ref } from 'vue';

import { useAuth } from '@/composables/auth/useAuth';
import { useNotification } from '@/composables/useNotification';
import { usePasswordRules } from '@/composables/usePasswordRules';

import BMDialog from '@/components/common/utilities/BMDialog.vue';
import BMPasswordField from '@/components/common/form/BMPasswordField.vue';

// Emits
const emit = defineEmits(['closeDialog']);

const { changePassword } = useAuth();

const isLoading = ref(false);
const oldPassword = ref('');
const newPassword = ref('');
const newPasswordRepeat = ref('');
const isFormValid = ref(true);

const { showErrorAlert, showSuccessAlert } = useNotification();
const { oldPwdRules, differentPwdRules, confirmPasswordRules } =
  usePasswordRules({
    password: newPassword,
    oldPassword: oldPassword
  });

const closeDialog = () => emit('closeDialog');

const updatePassword = async () => {
  if (oldPassword.value === newPassword.value) {
    showErrorAlert('accountHandling.changePassword.errors.samePassword');
    return;
  }

  try {
    isLoading.value = true;
    await changePassword(oldPassword.value, newPassword.value);
    closeDialog();
    showSuccessAlert();
  } catch (error) {
    console.error('Password update error:', error);
    showErrorAlert();
  } finally {
    isLoading.value = false;
  }
};
</script>
